var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.general_config"),
            isTitleUpperCase: false,
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "12" } }, [
                _c("label", { attrs: { for: "enable-tcp-keep-alive" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.active")) +
                      "\n"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.enableActive,
                          value: _vm.enableActive,
                        },
                        on: {
                          change: function ($event) {
                            _vm.enableActive = !_vm.enableActive
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: "",
                      inputLabel: _vm.$t("common.routing.config_name"),
                      placeholderValue: _vm.$t("common.routing.config_name"),
                    },
                    model: {
                      value: _vm.ConfigName,
                      callback: function ($$v) {
                        _vm.ConfigName = $$v
                      },
                      expression: "ConfigName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      maxLength: 512,
                      inputLabel: _vm.$t("common.routing.region"),
                      placeholderValue: _vm.$t("common.routing.region"),
                      tooltipLabel: _vm.$t("common.routing.region_info"),
                    },
                    model: {
                      value: _vm.Region,
                      callback: function ($$v) {
                        _vm.Region = $$v
                      },
                      expression: "Region",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.uri"),
                      placeholderValue: _vm.$t("common.routing.uri"),
                      tooltipLabel: _vm.$t("common.routing.uri_info"),
                    },
                    model: {
                      value: _vm.URI,
                      callback: function ($$v) {
                        _vm.URI = $$v
                      },
                      expression: "URI",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.port"),
                      placeholderValue: _vm.$t("common.routing.port"),
                      inputType: "number",
                      tooltipLabel: _vm.$t("common.routing.port_info"),
                    },
                    model: {
                      value: _vm.Port,
                      callback: function ($$v) {
                        _vm.Port = $$v
                      },
                      expression: "Port",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.bucket_name"),
                      placeholderValue: _vm.$t("common.routing.bucket_name"),
                      tooltipLabel: _vm.$t("common.routing.bucket_name_info"),
                    },
                    model: {
                      value: _vm.BucketName,
                      callback: function ($$v) {
                        _vm.BucketName = $$v
                      },
                      expression: "BucketName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.Prefix != ""
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel:
                            _vm.msgType == "2" &&
                            _vm.entitiesType == "2" &&
                            _vm.inputValue.Role == "1"
                              ? _vm.$t("common.routing.end_treatment_prefix")
                              : _vm.msgType == "2" &&
                                _vm.entitiesType == "2" &&
                                _vm.inputValue.Role == "0"
                              ? _vm.$t("common.routing.prefix_archiving")
                              : _vm.$t("common.routing.prefix"),
                          placeholderValue:
                            _vm.msgType == "2" &&
                            _vm.entitiesType == "2" &&
                            _vm.inputValue.Role == "1"
                              ? _vm.$t("common.routing.end_treatment_prefix")
                              : _vm.msgType == "2" &&
                                _vm.entitiesType == "2" &&
                                _vm.inputValue.Role == "0"
                              ? _vm.$t("common.routing.prefix_archiving")
                              : _vm.$t("common.routing.prefix"),
                        },
                        model: {
                          value: _vm.Prefix,
                          callback: function ($$v) {
                            _vm.Prefix = $$v
                          },
                          expression: "Prefix",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.PrefixArchiving != "" ||
              (_vm.entitiesType == "2" &&
                _vm.msgType == "2" &&
                _vm.inputValue.Role == "1")
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel:
                            _vm.entitiesType == "2" &&
                            _vm.msgType == "2" &&
                            _vm.inputValue.Role == "1"
                              ? _vm.$t("common.routing.prefix_case_error")
                              : _vm.$t("common.routing.prefix_archiving"),
                          placeholderValue:
                            _vm.entitiesType == "2" &&
                            _vm.msgType == "2" &&
                            _vm.inputValue.Role == "1"
                              ? _vm.$t("common.routing.prefix_case_error")
                              : _vm.$t("common.routing.prefix_archiving"),
                        },
                        model: {
                          value: _vm.PrefixArchiving,
                          callback: function ($$v) {
                            _vm.PrefixArchiving = $$v
                          },
                          expression: "PrefixArchiving",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.connect_option"),
            isTitleUpperCase: false,
            open: false,
          },
        },
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "scheme" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.scheme")) +
                      "\n            "
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: { title: _vm.$t("common.routing.scheme_info") },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.Scheme,
                        expression: "Scheme",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "scheme" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.Scheme = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "HTTPS", selected: "" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.https")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "HTTP" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.http")) + " "),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "use-dual-stack" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.use_dual_stack")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t("common.routing.use_dual_stack_info"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.useDualStack,
                          value: _vm.useDualStack,
                        },
                        on: {
                          change: function ($event) {
                            _vm.useDualStack = !_vm.useDualStack
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.max_connections"),
                      placeholderValue: _vm.$t(
                        "common.routing.max_connections"
                      ),
                      inputType: "number",
                      tooltipLabel: _vm.$t(
                        "common.routing.max_connections_info"
                      ),
                    },
                    model: {
                      value: _vm.maxConnections,
                      callback: function ($$v) {
                        _vm.maxConnections = $$v
                      },
                      expression: "maxConnections",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.request_timeout_ms"),
                      placeholderValue: _vm.$t(
                        "common.routing.request_timeout_ms"
                      ),
                      inputType: "number",
                      tooltipLabel: _vm.$t(
                        "common.routing.request_timeout_ms_info"
                      ),
                    },
                    model: {
                      value: _vm.RequestTimeoutMs,
                      callback: function ($$v) {
                        _vm.RequestTimeoutMs = $$v
                      },
                      expression: "RequestTimeoutMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.connect_timeout_ms"),
                      placeholderValue: _vm.$t(
                        "common.routing.connect_timeout_ms"
                      ),
                      inputType: "number",
                      tooltipLabel: _vm.$t(
                        "common.routing.connect_timeout_ms_info"
                      ),
                    },
                    model: {
                      value: _vm.ConnectTimeoutMs,
                      callback: function ($$v) {
                        _vm.ConnectTimeoutMs = $$v
                      },
                      expression: "ConnectTimeoutMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "enable-tcp-keep-alive" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.enable_tcp_keep_alive")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.enable_tcp_keep_alive_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.enableTcpKeepAlive,
                          value: _vm.enableTcpKeepAlive,
                        },
                        on: {
                          change: function ($event) {
                            _vm.enableTcpKeepAlive = !_vm.enableTcpKeepAlive
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: _vm.enableTcpKeepAlive === true,
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t(
                        "common.routing.tcp_keep_alive_inverval_ms"
                      ),
                      placeholderValue: _vm.$t(
                        "common.routing.tcp_keep_alive_inverval_ms"
                      ),
                      inputType: "number",
                      tooltipLabel: _vm.$t(
                        "common.routing.tcp_keep_alive_inverval_ms_info"
                      ),
                    },
                    model: {
                      value: _vm.tcpKeepAliveInvervalMs,
                      callback: function ($$v) {
                        _vm.tcpKeepAliveInvervalMs = $$v
                      },
                      expression: "tcpKeepAliveInvervalMs",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.low_speed_limit"),
                      placeholderValue: _vm.$t(
                        "common.routing.low_speed_limit"
                      ),
                      inputType: "number",
                      tooltipLabel: _vm.$t(
                        "common.routing.low_speed_limit_info"
                      ),
                    },
                    model: {
                      value: _vm.lowSpeedLimit,
                      callback: function ($$v) {
                        _vm.lowSpeedLimit = $$v
                      },
                      expression: "lowSpeedLimit",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.proxy_config"),
            isTitleUpperCase: false,
            open: false,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "proxy-active" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.proxy_active")) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.proxyActive,
                        expression: "proxyActive",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "proxy-active" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.proxyActive = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.yes")) + " "),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(" " + _vm._s(_vm.$t("common.routing.no")) + " "),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", { attrs: { for: "proxy-cheme" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.routing.proxy_scheme")) +
                            "\n            "
                        ),
                        _c("i", {
                          staticClass:
                            "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                          attrs: {
                            title: _vm.$t("common.routing.proxy_scheme_info"),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.proxyScheme,
                              expression: "proxyScheme",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: _vm.readonly, id: "proxy-scheme" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.proxyScheme = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            { attrs: { value: "HTTPS", selected: "" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("common.routing.https")) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "HTTP" } }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("common.routing.http")) + " "
                            ),
                          ]),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 10,
                          inputLabel: _vm.$t("common.routing.proxy_host"),
                          placeholderValue: _vm.$t("common.routing.proxy_host"),
                          tooltipLabel: _vm.$t(
                            "common.routing.proxy_host_info"
                          ),
                        },
                        model: {
                          value: _vm.proxyHost,
                          callback: function ($$v) {
                            _vm.proxyHost = $$v
                          },
                          expression: "proxyHost",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_port"),
                          placeholderValue: _vm.$t("common.routing.proxy_port"),
                          inputType: "number",
                          tooltipLabel: _vm.$t(
                            "common.routing.proxy_port_info"
                          ),
                        },
                        model: {
                          value: _vm.proxyPort,
                          callback: function ($$v) {
                            _vm.proxyPort = $$v
                          },
                          expression: "proxyPort",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.readonly,
                          maxLength: 512,
                          inputLabel: _vm.$t("common.routing.proxy_login"),
                          placeholderValue: _vm.$t(
                            "common.routing.proxy_login"
                          ),
                          tooltipLabel: _vm.$t(
                            "common.routing.proxy_login_info"
                          ),
                        },
                        model: {
                          value: _vm.proxyLogin,
                          callback: function ($$v) {
                            _vm.proxyLogin = $$v
                          },
                          expression: "proxyLogin",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.proxyActive == "1"
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("common.routing.proxy_pwd")) +
                            "\n            "
                        ),
                        _c("i", {
                          staticClass:
                            "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                          attrs: {
                            title: _vm.$t("common.routing.proxy_pwd_info"),
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex" }, [
                        _vm.proxyPasswordType === "checkbox"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxyPwd,
                                  expression: "proxyPwd",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.routing.proxy_pwd"),
                                disabled: _vm.readonly,
                                type: "checkbox",
                              },
                              domProps: {
                                checked: Array.isArray(_vm.proxyPwd)
                                  ? _vm._i(_vm.proxyPwd, null) > -1
                                  : _vm.proxyPwd,
                              },
                              on: {
                                change: function ($event) {
                                  var $$a = _vm.proxyPwd,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.proxyPwd = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.proxyPwd = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.proxyPwd = $$c
                                  }
                                },
                              },
                            })
                          : _vm.proxyPasswordType === "radio"
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxyPwd,
                                  expression: "proxyPwd",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.routing.proxy_pwd"),
                                disabled: _vm.readonly,
                                type: "radio",
                              },
                              domProps: { checked: _vm._q(_vm.proxyPwd, null) },
                              on: {
                                change: function ($event) {
                                  _vm.proxyPwd = null
                                },
                              },
                            })
                          : _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.proxyPwd,
                                  expression: "proxyPwd",
                                },
                              ],
                              staticClass:
                                "form-control inputAccordionForm h-30px",
                              attrs: {
                                placeholder: _vm.$t("common.routing.proxy_pwd"),
                                disabled: _vm.readonly,
                                type: _vm.proxyPasswordType,
                              },
                              domProps: { value: _vm.proxyPwd },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.proxyPwd = $event.target.value
                                },
                              },
                            }),
                        _vm._v(" "),
                        _c("div", {
                          staticClass:
                            "icon icon-password mt-2 pt-1 icon-field",
                          class: [
                            _vm.isProxyPasswordFieldHidden
                              ? "fa-duotone fa-eye"
                              : "fa-duotone fa-eye-slash",
                          ],
                          on: { click: _vm.switchProxyPasswordType },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.query_options"),
            isTitleUpperCase: false,
            open: false,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "follow-redirects" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.follow_redirects")) +
                      "\n            "
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t("common.routing.follow_redirects_info"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.FollowRedirects,
                        expression: "FollowRedirects",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.readonly, id: "follow-redirects" },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.FollowRedirects = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "Always" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.always")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "Never" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.never")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "option",
                      { attrs: { value: "Default", selected: "" } },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("common.routing.default")) + " "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "disable-expect-header" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.disable_expect_header")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.disable_expect_header_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.DisableExpectHeader,
                          value: _vm.DisableExpectHeader,
                        },
                        on: {
                          change: function ($event) {
                            _vm.DisableExpectHeader = !_vm.DisableExpectHeader
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  { attrs: { for: "enable-clock-skew-adjustement" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("common.routing.enable_clock_skew_adjustement")
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                      attrs: {
                        title: _vm.$t(
                          "common.routing.enable_clock_skew_adjustement_info"
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.EnableClockSkewAdjustement,
                          value: _vm.EnableClockSkewAdjustement,
                        },
                        on: {
                          change: function ($event) {
                            _vm.EnableClockSkewAdjustement =
                              !_vm.EnableClockSkewAdjustement
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  { attrs: { for: "enable-host-prefix-infection" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("common.routing.enable_host_prefix_infection")
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                      attrs: {
                        title: _vm.$t(
                          "common.routing.enable_host_prefix_infection_info"
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.enableHostPrefixInfection,
                          value: _vm.enableHostPrefixInfection,
                        },
                        on: {
                          change: function ($event) {
                            _vm.enableHostPrefixInfection =
                              !_vm.enableHostPrefixInfection
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "enable-endpoint-discovery" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("common.routing.enable_endpoint_discovery")
                      ) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.enable_endpoint_discovery_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.enableEndpointdiscovery,
                          value: _vm.enableEndpointdiscovery,
                        },
                        on: {
                          change: function ($event) {
                            _vm.enableEndpointdiscovery =
                              !_vm.enableEndpointdiscovery
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.advanced_s3_option"),
            isTitleUpperCase: false,
            open: false,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  { attrs: { for: "request-checksum-calculation" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("common.routing.request_checksum_calculation")
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                      attrs: {
                        title: _vm.$t(
                          "common.routing.request_checksum_calculation_info"
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.requestChecksumCalculation,
                        expression: "requestChecksumCalculation",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      disabled: _vm.readonly,
                      id: "request-checksum-calculation",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.requestChecksumCalculation = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.supported")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.required")) + " "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  { attrs: { for: "response-checksum-validation" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("common.routing.response_checksum_validation")
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                      attrs: {
                        title: _vm.$t(
                          "common.routing.response_checksum_validation_info"
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.responseChecksumValidation,
                        expression: "responseChecksumValidation",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      disabled: _vm.readonly,
                      id: "response-checksum-validation",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.responseChecksumValidation = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.supported")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.required")) + " "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "use-virtual-addressing" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.use_virtual_addressing")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.use_virtual_addressing_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.useVirtualAddressing,
                          value: _vm.useVirtualAddressing,
                        },
                        on: {
                          change: function ($event) {
                            _vm.useVirtualAddressing = !_vm.useVirtualAddressing
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c(
                  "label",
                  { attrs: { for: "disable-multi-region-access-points" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "common.routing.disable_multi_region_access_points"
                          )
                        ) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                      attrs: {
                        title: _vm.$t(
                          "common.routing.disable_multi_region_access_points_info"
                        ),
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.disableMultiRegionAccessPoints,
                          value: _vm.disableMultiRegionAccessPoints,
                        },
                        on: {
                          change: function ($event) {
                            _vm.disableMultiRegionAccessPoints =
                              !_vm.disableMultiRegionAccessPoints
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "use-arn-region" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.use_arn_region")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t("common.routing.use_arn_region_info"),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.useArnRegion,
                          value: _vm.useArnRegion,
                        },
                        on: {
                          change: function ($event) {
                            _vm.useArnRegion = !_vm.useArnRegion
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "payload-signing-policy" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.payload_signing_policy")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.payload_signing_policy_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.payloadSigningPolicy,
                        expression: "payloadSigningPolicy",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      disabled: _vm.readonly,
                      id: "payload-signing-policy",
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.payloadSigningPolicy = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "0", selected: "" } }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("common.routing.request_dependent")) +
                          " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "1" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.always")) + " "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "2" } }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.routing.never")) + " "
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", { attrs: { for: "disable-s3-express-auth" } }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("common.routing.disable_s3_express_auth")) +
                      "\n            "
                  ),
                  _c("i", {
                    staticClass:
                      "fa-duotone fa-circle-info cursor text-info tooltipIcon",
                    attrs: {
                      title: _vm.$t(
                        "common.routing.disable_s3_express_auth_info"
                      ),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "item-input",
                    attrs: { disabled: _vm.readonly },
                  },
                  [
                    _c("label", { staticClass: "label-switch" }, [
                      _c("input", {
                        staticClass: "checkService",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.disableS3ExpressAuth,
                          value: _vm.disableS3ExpressAuth,
                        },
                        on: {
                          change: function ($event) {
                            _vm.disableS3ExpressAuth = !_vm.disableS3ExpressAuth
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "checkbox" }),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("hr", { staticClass: "mx-auto" }),
      _vm._v(" "),
      _c(
        "form-accordion",
        {
          attrs: {
            title: _vm.$t("common.routing.additional_option"),
            isTitleUpperCase: false,
            open: false,
          },
        },
        [
          _c(
            "b-row",
            { staticClass: "form-group" },
            [
              _vm.inputValue.Role != 1
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("form-write-group-label-input", {
                        attrs: {
                          disabled: _vm.inputValue.Role == 1 || _vm.readonly,
                          inputLabel: _vm.$t("common.routing.min_buffer_size"),
                          tooltipLabel:
                            _vm.inputValue.Role == 1
                              ? undefined
                              : _vm.$t("common.routing.min_buffer_output_size"),
                          placeholderValue: _vm.$t(
                            "common.routing.min_buffer_size"
                          ),
                        },
                        model: {
                          value: _vm.MinBufferSize,
                          callback: function ($$v) {
                            _vm.MinBufferSize = $$v
                          },
                          expression: "MinBufferSize",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      disabled: _vm.readonly,
                      inputLabel: _vm.$t("common.routing.max_buffer_size"),
                      tooltipLabel:
                        _vm.inputValue.Role == 1
                          ? _vm.$t("common.routing.max_buffer_size_input")
                          : _vm.$t("common.routing.max_buffer_size_output"),
                      placeholderValue: _vm.$t(
                        "common.routing.max_buffer_size"
                      ),
                    },
                    model: {
                      value: _vm.MaxBufferSize,
                      callback: function ($$v) {
                        _vm.MaxBufferSize = $$v
                      },
                      expression: "MaxBufferSize",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.inputValue.Role == 1
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("datetime-picker-custom", {
                        staticClass: "z-1",
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.BeginDate,
                        },
                        attrs: {
                          format: "DD/MM/YYYY H:i:s",
                          inputLabel: _vm.$t("common.routing.begin_date"),
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          tooltipLabel:
                            _vm.inputValue.Role == 1
                              ? _vm.$t("common.routing.date_begin_input")
                              : undefined,
                          placeholderValue: _vm.$t(
                            "common.datetime_picker_empty_date"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                          disabled: _vm.inputValue.Role == 0 || _vm.readonly,
                        },
                        model: {
                          value: _vm.BeginDate,
                          callback: function ($$v) {
                            _vm.BeginDate = $$v
                          },
                          expression: "BeginDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("datetime-picker-custom", {
                        staticClass: "z-1",
                        class: {
                          "filter-item-input": true,
                          "filter-item-input-complete": _vm.EndDate,
                        },
                        attrs: {
                          format: "DD/MM/YYYY H:i:s",
                          inputLabel: _vm.$t("common.routing.end_date"),
                          customInputParentClass: "filter-item-content",
                          customInputClass: "w-100",
                          maxLength: 19,
                          placeholderValue: _vm.$t(
                            "common.datetime_picker_empty_date"
                          ),
                          inputIcon: "fa-solid fa-calendar",
                          disabled: "",
                        },
                        model: {
                          value: _vm.EndDate,
                          callback: function ($$v) {
                            _vm.EndDate = $$v
                          },
                          expression: "EndDate",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("b-row"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }